import { connect } from 'react-redux';
import { getNumberOfKO } from 'state/blotters/trades/tradesBlotters.selector';
import type { AppState } from 'state/state.model';

import type { CreditCheckBadgeStatusProps } from './CreditCheckBadge';
import { CreditCheckBadgeComponent } from './CreditCheckBadge';

export const mapStateToProps = (state: AppState): CreditCheckBadgeStatusProps => ({
  numberOfKO: getNumberOfKO(state),
});

export const CreditCheckBadge = connect(mapStateToProps)(CreditCheckBadgeComponent);
